<script>

    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    function back() {
        dispatch('back', {});
    }

</script>

<div class="flex flex-row w-full max-h-52">
    <div class="h-full  w-2/4  flex flex-col bg-white text-center justify-center">
        <div>
            <br/>
        </div>
        <div>
            <img src="/logo.png"/>
        </div>
        <div>
            <br/>
        </div>
    </div>
    <div class="w-2/4 flex flex-col bg-blue-1  text-center justify-center" on:click={back}>
        <div>
            <span class="text-2xl md:text-3xl"><i class="fas fa-arrow-left blue-3 mr-4"></i>Wstecz</span>
        </div>
    </div>
</div>